module.exports = __webpack_public_path__ + "img/gd.eeb7ce07.svg";